import { StoreAction, XmAction } from 'store/actions';
import { NowUser } from './models';

export function nowUserReducer(state: NowUser, action: XmAction<NowUser>): NowUser {
    switch (action.type) {
        case StoreAction.GET_USER_INFO:
            return action.payload;

        default:
            return state;
    }
}
